import { shortFormatNumber } from '../../util'

export function tickFormatter(value: any) {
  return shortFormatNumber(value, { fractions: Math.abs(value) >= 1_000 ? 0 : 2 })
}
